/** 价税拆分（默认软件服务 6% 税率，金额为含税价） */
export function splitTaxInclusive(total, rate = 0.06) {
  const totalNum = Math.max(0, Number(total) || 0);
  if (!totalNum) {
    return { amount: '0.00', tax: '0.00', total: '0.00' };
  }
  const amount = totalNum / (1 + rate);
  const tax = totalNum - amount;
  return {
    amount: amount.toFixed(2),
    tax: tax.toFixed(2),
    total: totalNum.toFixed(2),
  };
}

/** 金额转中文大写（圆角分） */
export function amountToChinese(amount) {
  const num = Math.round((Number(amount) || 0) * 100) / 100;
  if (num <= 0) return '零圆整';

  const CN_NUM = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const CN_UNIT = ['', '拾', '佰', '仟'];
  const CN_SECTION = ['', '万', '亿'];

  const yuan = Math.floor(num);
  const jiao = Math.floor((num * 10) % 10);
  const fen = Math.round(num * 100) % 10;

  function sectionToChinese(n) {
    if (!n) return '';
    let str = '';
    let zero = false;
    for (let i = 0; n > 0; i += 1) {
      const digit = n % 10;
      if (digit === 0) {
        zero = true;
      } else {
        if (zero) str = CN_NUM[0] + str;
        str = CN_NUM[digit] + CN_UNIT[i] + str;
        zero = false;
      }
      n = Math.floor(n / 10);
    }
    return str;
  }

  let result = '';
  let sectionIndex = 0;
  let n = yuan;
  while (n > 0) {
    const section = n % 10000;
    if (section) {
      const sectionStr = sectionToChinese(section);
      result = sectionStr + CN_SECTION[sectionIndex] + result;
    }
    n = Math.floor(n / 10000);
    sectionIndex += 1;
  }
  result = (result || CN_NUM[0]) + '圆';

  if (jiao === 0 && fen === 0) {
    result += '整';
  } else {
    if (jiao) result += CN_NUM[jiao] + '角';
    else if (fen) result += '零';
    if (fen) result += CN_NUM[fen] + '分';
    else if (jiao) result += '整';
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/view/client/personal-center/panels/InvoiceCenter/invoicePreviewUtils.js